import { Loader } from '@ophelos/ui/components/loader';
import { useAuth } from '@ophelos/ui/contexts/workos-auth-context';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export function CallbackPage() {
  const navigate = useNavigate();
  const { isAuthenticated, isLoading } = useAuth();

  useEffect(() => {
    if (isLoading) return;
    // Wait for AuthKit to finish exchanging the one-time code. Navigating to
    // /apps while still unauthenticated makes ProtectedRoute do a full-page
    // send to /login, which drops the callback URL and loops.
    navigate(isAuthenticated ? '/apps' : '/login', { replace: true });
  }, [isAuthenticated, isLoading, navigate]);

  return <Loader text="Completing sign in..." fullScreen />;
}
